<template>
  <DsShowcase title="DropdownPlay" description="Dropdown de ações com posicionamento, ícones e opções configuráveis.">
    <!-- PROP: options -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">options</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>Array&lt;{ label, value?, icon?, color? }&gt;</code> — lista de opções. Emite <code>@select</code> ao clicar.</p>
      <div class="tw:flex tw:gap-6 tw:flex-wrap">
        <DropdownPlay :options="basicOptions" @select="lastSelected = $event.label">
          <template #trigger>
            <ButtonPlayV2 text="Ações" icon="more_vert" variant="outline" />
          </template>
        </DropdownPlay>
        <span class="tw:text-sm tw:self-center tw:opacity-60">Último selecionado: {{ lastSelected || '—' }}</span>
      </div>
    </section>

    <!-- Options com ícones e cores -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Options com icon e color</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">Cada option pode ter <code>icon</code> (Material Symbols) e <code>color</code></p>
      <div class="tw:flex tw:gap-6 tw:flex-wrap">
        <DropdownPlay :options="iconOptions">
          <template #trigger>
            <ButtonPlayV2 text="Gerenciar" icon="settings" />
          </template>
        </DropdownPlay>
      </div>
    </section>

    <!-- PROP: position -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">position</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'top' | 'bottom' | 'left' | 'right'</code> — padrão: <code>bottom</code></p>
      <div class="tw:flex tw:gap-6 tw:flex-wrap tw:py-16">
        <DropdownPlay :options="positionOptions" position="bottom">
          <template #trigger>
            <ButtonPlayV2 text="Bottom" variant="outline" size="sm" />
          </template>
        </DropdownPlay>
        <DropdownPlay :options="positionOptions" position="top">
          <template #trigger>
            <ButtonPlayV2 text="Top" variant="outline" size="sm" />
          </template>
        </DropdownPlay>
        <DropdownPlay :options="positionOptions" position="right">
          <template #trigger>
            <ButtonPlayV2 text="Right" variant="outline" size="sm" />
          </template>
        </DropdownPlay>
        <DropdownPlay :options="positionOptions" position="left">
          <template #trigger>
            <ButtonPlayV2 text="Left" variant="outline" size="sm" />
          </template>
        </DropdownPlay>
      </div>
    </section>

    <!-- Slot: trigger customizado -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Slot #trigger</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">Qualquer elemento pode ser o trigger</p>
      <div class="tw:flex tw:gap-6 tw:flex-wrap">
        <DropdownPlay :options="basicOptions">
          <template #trigger>
            <ButtonPlayV2 icon="more_horiz" variant="ghost" size="sm" />
          </template>
        </DropdownPlay>
        <DropdownPlay :options="basicOptions">
          <template #trigger>
            <span class="tw:text-sm tw:underline tw:cursor-pointer">Link como trigger</span>
          </template>
        </DropdownPlay>
      </div>
    </section>

    <!-- Slot: area (conteúdo livre) -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Slot #area</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">Substitui as opções por conteúdo completamente customizado</p>
      <div class="tw:flex tw:gap-6 tw:flex-wrap">
        <DropdownPlay>
          <template #trigger>
            <ButtonPlayV2 text="Conteúdo custom" variant="outline" icon="tune" />
          </template>
          <template #area>
            <div class="tw:p-3 tw:space-y-2 tw:w-56">
              <p class="tw:text-xs tw:font-semibold tw:opacity-60 tw:uppercase">Filtros</p>
              <label class="tw:flex tw:items-center tw:gap-2 tw:text-sm tw:cursor-pointer">
                <input type="checkbox" checked /> Ativos
              </label>
              <label class="tw:flex tw:items-center tw:gap-2 tw:text-sm tw:cursor-pointer">
                <input type="checkbox" /> Inativos
              </label>
              <label class="tw:flex tw:items-center tw:gap-2 tw:text-sm tw:cursor-pointer">
                <input type="checkbox" /> Arquivados
              </label>
            </div>
          </template>
        </DropdownPlay>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { DropdownPlay, ButtonPlayV2 } from "@/components/atomic"


const lastSelected = ref('')

const basicOptions = [
  { label: 'Editar', value: 'edit' },
  { label: 'Duplicar', value: 'duplicate' },
  { label: 'Mover', value: 'move' },
  { label: 'Excluir', value: 'delete' },
]

const iconOptions = [
  { label: 'Editar', value: 'edit', icon: 'edit' },
  { label: 'Duplicar', value: 'duplicate', icon: 'content_copy' },
  { label: 'Compartilhar', value: 'share', icon: 'share' },
  { label: 'Excluir', value: 'delete', icon: 'delete', color: '#e53e3e' },
]

const positionOptions = [
  { label: 'Opção A', value: 'a' },
  { label: 'Opção B', value: 'b' },
  { label: 'Opção C', value: 'c' },
]
</script>
